enum AgreementsRoutesEnum {
  AgreementsList = '/user-agreements',
  TermsOfUse = '/user-agreements/terms-of-use',
  DataProcessingPolicy = '/user-agreements/personal-data-processing-policy',
  UESAgreement = '/user-agreements/use-of-ues',
}

export default AgreementsRoutesEnum;
